import { useI18n, type MessageKey } from '@/i18n'
import type { ScanRefusal } from '../commands'

/** Reason code → the sentence the person reads (current language). */
export function useRefusalText() {
  const { t } = useI18n()
  return (r: ScanRefusal | 'DUPLICATE') => t(`store.refusal.${r}` as MessageKey)
}
